import { AgentDetailsUser, StyleObj } from '../../../../@types';
import { Divider, Stack } from '@mui/material';
import { useUpdateAgentData } from '../../../../queries';
import useLocalization from '../../../../hooks/useLocalization';
import dayjs from 'dayjs';
import StyledDetailsRow from '../atoms/StyledDetailsRow';
import UserDetailsFormModal from './UserDetailsFormModal';
import { useModal } from '../../../../hooks/useDialog';
import { SKINNED_COMMON_MODAL_PROPS } from '../../../../utils/skin-utils/modals';
import { useSkinConfigs } from '../../../../hooks/useSkinConfigs';
import { UseMutateFunction } from '@tanstack/react-query';

interface Row {
  label: string;
  value: string;
  clickDisabled?: boolean;
  fieldName?: 'firstName' | 'lastName' | 'password';
  handleUpdate?: UseMutateFunction<AgentDetailsUser, unknown, AgentDetailsUser, unknown>;
}

const styles: StyleObj = {
  container: {
    m: '10px',
    border: '1px solid',
    borderColor: 'neutral.25',
    borderRadius: '10px',
    backgroundColor: 'neutral.600',
  },
};

const UserDetailsForm = ({ userData }: { userData: AgentDetailsUser }) => {
  const { t } = useLocalization();
  const { mutate: updateAgentData } = useUpdateAgentData(userData?.id || '');
  const userId = userData?.id || '';
  const lastOnlineDate = userData.lastOnline ? dayjs(userData.lastOnline).format('DD/MM/YYYY HH:mm') : '--';

  const rows: Row[] = [
    { label: t('lastLogin'), value: lastOnlineDate, clickDisabled: true },
    { label: t('firstName'), fieldName: 'firstName' as const, value: userData.firstName ?? '' },
    { label: t('surname'), fieldName: 'lastName' as const, value: userData.lastName ?? '' },
    { label: t('password'), fieldName: 'password' as const, value: '' },
  ];
  const modalConfig = useSkinConfigs(SKINNED_COMMON_MODAL_PROPS);

  const { openModal } = useModal();
  const handleModal = (row: Row) => {
    if (row.clickDisabled || !row.fieldName) return;
    openModal(
      <UserDetailsFormModal
        title={row.label}
        fieldName={row.fieldName}
        userId={userId}
        handleUpdate={updateAgentData}
      />,
      modalConfig
    );
  };

  return (
    <Stack divider={<Divider sx={{ borderColor: 'neutral.25' }} />} sx={styles.container}>
      {rows.map((row, i) => (
        <StyledDetailsRow key={i} {...row} onRowClick={() => handleModal(row)} />
      ))}
    </Stack>
  );
};

export default UserDetailsForm;
